import { getLink } from '../../../../utils/utils';

import author from './author';

const cite1Text = (
	`В древнем Китае очень популярным было изготовление воздушных змеев из бумаги. Часто устраивались сражения таких змеев, вооруженных специальными клинками. `
)
const cite1 = (
	`<sup><acronym title="${cite1Text}"><a href="#cite_note1" id="cite_ref1">*</a></acronym></sup>`
)

const content = {
	rus: (
		`
		<div style="text-align: justify;">
			<p class="mb-3">
				Я был свободным и сильным, я парил над облаками, мчась наперегонки с ветром.
			</p>
			
			<p class="mb-3">
				Нет никого, кто сравнился бы со мной! 
				Я один царю над Поднебесной!
			</p>
			
			<p class="mb-3">
				Но что это? Вот с юга появился соперник. 
				Он тоже хочет быть царём воздуха, он бросает мне вызов! 
				Давно он оскорблял меня своим видом. 
				Ну что же, сегодня ты не уйдёшь от расплаты! 
				Бросок, ещё бросок… 
				Он падает вниз, разодранный моими когтями${cite1}.
			</p>
			
			<p class="mb-3">
				Победа! Я торжествую, купаясь в солнечных лучах.
			</p>
			
			<p class="mb-3">
				Но вот внезапно что-то тянет меня вниз. 
				С вершины радости я грубо брошен на землю. 
				Меня берут, складывают и несут домой, где прячут в тёмный сундук. 
			</p>
			
			<p class="mb-3">
				Я – воздушный змей. 
			</p>

		</div>
		`
	)
}

const itemName = {
	rus: `Свобода`
}

const itemDate = {
	rus: '15 марта 2018 г.'
}
const item = {
	itemlink: getLink(itemName.rus),
	rus: {
		itemName: itemName.rus,
		itemDate: itemDate.rus,
		itemContent: content.rus,
		itemAuthor: author.rus
	}
}

export default item;